import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
// import DiscountsPage from "../views/DiscountsPage.vue";
// import CarouselPage from "../views/CarouselPage.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home
  },
  // {
  //   path: "/.well-known",
  //   redirect: '/apple-developer-merchantid-domain-association'
  // },
  // {
  //   path: "/1c4aa15b-f0e6-4e54-8932-dd432e70ad2a",
  //   name: "DiscountsPage",
  //   component: DiscountsPage
  // },
  // {
  //   path: "/6f43fd0a-3595-48ee-bb13-cf1a86510809",
  //   name: "CarouselPage",
  //   component: CarouselPage
  // },
  {
    path: "*",
    name: "Error",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ "../views/404.vue")
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
